"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.indicatorExtendedSchema = void 0;
var constants_1 = require("@hobt/constants");
var indicator_schema_1 = require("./indicator-schema");
exports.indicatorExtendedSchema = __assign(__assign({}, indicator_schema_1.indicatorSchema), { allOf: [
        {
            if: {
                properties: {
                    indicator: {
                        required: ['underwritingReviewEndDate'],
                    },
                },
            },
            then: {
                properties: {
                    underwritingReviewEndDate: {
                        type: 'string',
                        formatMinimum: {
                            $data: '1/underwritingInformationReceivedDate',
                            customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_INDICATOR_DATE_0, 'underwritingReviewEndDate'),
                        },
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    indicator: {
                        required: ['underwritingInformationReceivedDate'],
                    },
                },
            },
            then: {
                properties: {
                    underwritingInformationReceivedDate: {
                        type: 'string',
                        formatMinimum: {
                            $data: '1/underwritingInformationRequestedDate',
                            customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_INDICATOR_DATE_1, 'underwritingInformationReceivedDate'),
                        },
                    },
                },
            },
        },
    ] });
